import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, toHandlers as _toHandlers } from "vue"

const _hoisted_1 = {
  id: "platmap-modal",
  class: "embinfobox basic"
}
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass(['map-card'])
}
const _hoisted_3 = { class: "flexRow items-end lot-top-block" }
const _hoisted_4 = { class: "lotid-title" }
const _hoisted_5 = {
  key: 0,
  class: "location-block"
}
const _hoisted_6 = { class: "location-block-title wo-line" }
const _hoisted_7 = { class: "location-block-icon" }
const _hoisted_8 = { class: "location-block-title font-semibold" }
const _hoisted_9 = {
  key: 1,
  class: "lotinfo-mktitle"
}
const _hoisted_10 = {
  key: 0,
  class: "tabs",
  style: {"margin-bottom":"6px"}
}
const _hoisted_11 = {
  type: "radio",
  name: "tabs",
  id: "tabone",
  checked: ""
}
const _hoisted_12 = { for: "tabone" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "tab"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "flexDiv mb-5 mt-5" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "price-block" }
const _hoisted_22 = {
  key: 0,
  class: "price-block-panel-text"
}
const _hoisted_23 = { class: "price-block-panel" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "amenities-list mb-8" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { key: 4 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 5 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { class: "carousel-navigation" }
const _hoisted_51 = { for: "tabtwo" }
const _hoisted_52 = { class: "tab site-photo" }
const _hoisted_53 = { class: "tab-slider relative" }
const _hoisted_54 = {
  key: 0,
  class: "slider-caption"
}
const _hoisted_55 = { class: "carousel-navigation" }
const _hoisted_56 = { class: "flexDiv" }
const _hoisted_57 = { class: "homePlan-name green" }
const _hoisted_58 = { class: "amenities-list" }
const _hoisted_59 = {
  key: 0,
  class: "location-block-date"
}
const _hoisted_60 = {
  type: "radio",
  name: "tabs",
  id: "tabone",
  checked: ""
}
const _hoisted_61 = { for: "tabone" }
const _hoisted_62 = {
  key: 0,
  class: "flexDiv"
}
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "tab-slider" }
const _hoisted_65 = {
  key: 0,
  class: "slider-caption"
}
const _hoisted_66 = { class: "carousel-navigation" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  key: 1,
  class: "flexDiv mb-5"
}
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "price-block" }
const _hoisted_72 = {
  key: 0,
  class: "price-block-panel"
}
const _hoisted_73 = {
  key: 0,
  class: "understrike"
}
const _hoisted_74 = { class: "amenities-list mb-8" }
const _hoisted_75 = {
  key: 0,
  class: "under-construction-list"
}
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { key: 2 }
const _hoisted_78 = { key: 3 }
const _hoisted_79 = { key: 4 }
const _hoisted_80 = { key: 5 }
const _hoisted_81 = { key: 6 }
const _hoisted_82 = { for: "tabtwo" }
const _hoisted_83 = { class: "tab site-photo" }
const _hoisted_84 = { class: "tab-slider relative" }
const _hoisted_85 = {
  key: 0,
  class: "slider-caption"
}
const _hoisted_86 = { class: "carousel-navigation" }
const _hoisted_87 = { class: "flexDiv" }
const _hoisted_88 = { class: "homePlan-name green" }
const _hoisted_89 = { class: "amenities-list" }
const _hoisted_90 = { key: 2 }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { class: "sold" }
const _hoisted_93 = { class: "homePlan-name mb-8" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = {
  key: 0,
  class: "tab"
}
const _hoisted_96 = { class: "tab-slider" }
const _hoisted_97 = {
  key: 3,
  class: "soldHomes-msg"
}
const _hoisted_98 = { key: 1 }

import { ref, reactive, computed, onMounted, nextTick, toRefs, inject } from "vue";
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import LazyImage from "./../LazyImage.vue";
import Location from "@/assets/icons/Location.vue";
import lodash from "lodash";
import {
  CommunityQmiDetails,
  HomesPlan,
  LotDetail,
  LotInfo,
  PlanNeighborhoodList,
} from "./../../types";
import { Status, Scalers, LinkOpenConatactInfo } from "./../../constant";
import { apiMessages } from "../../api/message-api";
import { addImageScaler, convertToTitleCase, formatPrice } from "@/core";
import { isIE } from "mobile-device-detect";
import SoldPendingStatus from "@/assets/icons/SoldPendingStatus.vue";
import SoldContingencyStatus from "@/assets/icons/SoldContengencyStatus.vue";

const errorMessage = "Information for this lot is not yet available";

export default /*@__PURE__*/_defineComponent({
  __name: 'PlatMapInfoWindow',
  props: {
    lotId: {},
    lotInfo: {},
    isKioskMode: { type: Boolean },
    neighborhoodId: {},
    updateLotInfo: { type: Function },
    mobileOpenContactInfo: { type: Function }
  },
  emits: ["openModal"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  lotId,
  lotInfo,
  isKioskMode,
  neighborhoodId,
  updateLotInfo,
  mobileOpenContactInfo,
} = toRefs(props);
const emit = __emit;


const carouselConfig = {
  itemsToShow: 1,
  itemsToScroll: 1,
  wrapAround: false,
};
const availableStatus = Status;
const messages = reactive<any>({});
const loading = isIE;
const trailingText = ref<string[]>([]);
const linkOpenConatactInfo = LinkOpenConatactInfo;
const showDefaultImage = ref(false);

const slick = ref();
const siteSlick = ref();

const isSalesOrLandView = inject('setSelectionDropdown', ref(false));


onMounted(() => {
  updateLotInfo.value({ lotInfo: lotInfo.value, lotId: lotId.value });
  loadMessages();
});

const loadMessages = async () => {
  const { messages: msg } = await apiMessages("PlatMapModal");
  Object.assign(messages, msg);
  trailingText.value = msg.soldHomesMessage.split(linkOpenConatactInfo);
};

const handleReInit = () => {
  nextTick(() => {
    slick.value?.reSlick();
  });
};

const handleSiteReInit = () => {
  nextTick(() => {
    siteSlick.value?.reSlick();
  });
};

const checkLowRange = (
  property1: string,
  property2: string,
  homePlan: HomesPlan
) => {
  return (
    (![availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != null &&
      homePlan[property1]) ||
    ([availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != homePlan[property2] &&
      homePlan[property1])
  );
};
const checkLowRangeHalfBath = (
  property1: string,
  property2: string,
  homePlan: HomesPlan
) => {
  return (
    (![availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != null) ||
    ([availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) &&
      homePlan[property1] != homePlan[property2] &&
      homePlan[property1] != null)
  );
};

const convertToTitleCaseFn = (val: string) => convertToTitleCase(val);
const formatPriceFn = (val: number) => formatPrice(val);
const formatSquareFeet = (x: number) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const formatDate = (moveInDate: string) => {
  let date = new Date(moveInDate);
  let formattedDate = date.toDateString().split(" ");
  return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
};

const isRange = (val_low: any, val_high: any) =>
  val_low != null && val_low != val_high && val_high && val_low;

const isRangeHalfBath = (val_low: any, val_high: any) =>
  val_low != null && val_high != null && val_high != 0 && val_low != val_high;

const suppressScheduleVisit = () =>
  [
    availableStatus.SOLD,
    availableStatus.RESERVED,
    availableStatus.FUTURE_HOME,
  ].includes(lotInfo.value.lot.status) || isKioskMode.value;

const NTER_NOW_URL_PATTERN = /^https?:\/\//i;

/**
 * NterNow self-guided tour link for a Quick Move-In home. Empty unless the QMI
 * publishes a usable link and the Schedule a Visit CTA would otherwise show.
 */
const selfGuidedTourUrl = computed(() => {
  if (isSalesOrLandView.value || suppressScheduleVisit()) return "";
  if (
    ![availableStatus.QMI, availableStatus.QUICK_MOVE_IN].includes(
      lotInfo.value?.lot?.status
    )
  )
    return "";

  const nterNowUrl = lotInfo.value?.homes_plans?.[0]?.nter_now_url?.trim() ?? "";
  return NTER_NOW_URL_PATTERN.test(nterNowUrl) ? nterNowUrl : "";
});

const openSelfGuidedTour = () => {
  window.open(selfGuidedTourUrl.value, "_blank");
};

const openPlanDetails = (planURL: Location) => {
  window.open(`${planURL}`, `HomePlans_WindowName`);
};

const openKioskPlanView = (planCode: string) => {
  // console.log('PlatMapInfoWindow...');
  // console.log('planCode = ' + planCode);
  // console.log('jobNumber? = ' + lotInfo.value.lot.id);
  // console.log('nbCode?: ' + lotId.value.split("-")[0]);
  // console.log('selectedneighborhoodIds:');
  // console.log(JSON.stringify(neighborhoodId.value));
  console.log('lotInfo = ');
  console.log(JSON.stringify(lotInfo.value) || 'no lotinfo');
  let nbCode = lotInfo.value.lot.id.split("-")[0] || '';
  let pCode = planCode || '';
  let kioskPlanLink = `${process.env.VUE_APP_URL}planView?`;
  if (lotStatus.value === availableStatus.AVAILABLE.toLowerCase()) {
  //  console.log('neighborhoodId:');
  //  console.log(JSON.stringify(neighborhoodId.value));
    kioskPlanLink += `plan_code=${pCode}&neighborhood_code=${nbCode}`;
  } else if (lotStatus.value === "qmi") {
    kioskPlanLink += `job_number=${lotInfo.value.lot.id}&neighborhood_code=${nbCode}`;
  }
  window.open(`${kioskPlanLink}`, `HomePlans_WindowName`);
};

const checkRangeAndFutureHome = (homePlan: HomesPlan) =>
  isRange(homePlan.price_low, homePlan.price_high) &&
  lotInfo.value.lot.status !== availableStatus.FUTURE_HOME;

const imageSource = (src: any) => {
  if (typeof src === "object" && src.image_url) {
    return addScaler(src.image_url);
  } else {
    showDefaultImage.value = true;
    return require("@/assets/images/home-not-available.png");
  }
};

const addScaler = (url: string) => addImageScaler(url);

const showHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans.length &&
    [availableStatus.AVAILABLE, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    )
);

const showFutureHomePlanLabel = computed(
  () =>
    lotInfo.value.homes_plans.length &&
    [availableStatus.FUTURE_HOME].includes(lotInfo.value.lot.status)
);

const showSoldMessage = computed(
  () =>
    [availableStatus.SOLD, availableStatus.FUTURE_HOME].includes(
      lotInfo.value.lot.status
    ) || isKioskMode.value
);

const lotStatus = computed(() => {
  let status = lotInfo.value.lot.status;
  if ([availableStatus.QUICK_MOVE_IN].includes(status)) status = "qmi";
  else if ([availableStatus.SOLD, availableStatus.AVAILABLE].includes(status))
    status = status.toLowerCase();
  return status;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[23] || (_cache[23] = _createElementVNode("i", {
          "aria-label": "close icon",
          class: "emb_closeicon"
        }, null, -1)),
        (!_unref(lodash).isEmpty(_unref(lotInfo)))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["map-card-body", lotStatus.value])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flexCol mb-4", lotStatus.value])
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, "Site " + _toDisplayString(_unref(lotId)), 1),
                  _createElementVNode("span", {
                    class: "lotinfo-colors",
                    style: _normalizeStyle({ color: _unref(lotInfo).lot.color })
                  }, [
                    (_unref(lotInfo).lot.status === 'Sold Pending')
                      ? (_openBlock(), _createBlock(SoldPendingStatus, {
                          key: 0,
                          svgClass: "dsize"
                        }))
                      : (_unref(lotInfo).lot.status === 'Sold Contingency')
                        ? (_openBlock(), _createBlock(SoldContingencyStatus, {
                            key: 1,
                            svgClass: "dsize"
                          }))
                        : (_openBlock(), _createElementBlock("i", {
                            key: 2,
                            style: _normalizeStyle({ backgroundColor: _unref(lotInfo).lot.color }),
                            class: "dsize"
                          }, null, 4)),
                    _createTextVNode(" " + _toDisplayString(_unref(lotInfo).lot.status === 'QMI' ? 'Quick Move-In' : _unref(lotInfo).lot.status), 1)
                  ], 4)
                ]),
                (_unref(lotInfo).lot.address)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(lotInfo).lot.address), 1),
                      _createElementVNode("i", _hoisted_7, [
                        _createVNode(Location)
                      ]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(lotInfo).neighborhoodName), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
                _unref(lotInfo).lot.marketing_headline &&
                ![_unref(availableStatus).SOLD, _unref(availableStatus).RESERVED].includes(
                  _unref(lotInfo).lot.status
                )
              )
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_unref(lotInfo).lot.marketing_headline), 1))
                  : _createCommentVNode("", true)
              ], 2),
              (
              [_unref(availableStatus).AVAILABLE, _unref(availableStatus).FUTURE_HOME].includes(
                _unref(lotInfo).lot.status
              )
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", _hoisted_11, null, 512), [
                      [_vShow, _unref(lotInfo).homes_plans.length]
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_12, [
                      (!showFutureHomePlanLabel.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(`${_unref(lotInfo).homes_plans.length || 0} home plans available`), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "Home Plans"))
                    ], 512), [
                      [_vShow, showHomePlanLabel.value]
                    ]),
                    (_unref(lotInfo).homes_plans.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (!!_unref(lotInfo).homes_plans.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "tab-slider",
                                style: _normalizeStyle({ display: _unref(loading) ? 'none' : '' })
                              }, [
                                (!!_unref(lotInfo).homes_plans.length)
                                  ? (_openBlock(), _createBlock(_unref(Carousel), _normalizeProps(_mergeProps({ key: 0 }, carouselConfig)), {
                                      addons: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createVNode(_unref(Navigation))
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lotInfo).homes_plans, (homePlan) => {
                                          return (_openBlock(), _createBlock(_unref(Slide), {
                                            key: homePlan.id
                                          }, {
                                            default: _withCtx(() => [
                                              (!!homePlan.image_url.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                    _createVNode(LazyImage, {
                                                      src: imageSource(homePlan.image_url[0]),
                                                      alt: 
                          !!homePlan.image_url.length
                            ? homePlan.image_url[0].caption
                            : homePlan.name
                        ,
                                                      isNeighborhoodImage: false,
                                                      showDefaultImage: showDefaultImage.value
                                                    }, null, 8, ["src", "alt", "showDefaultImage"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (!!!homePlan.image_url.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    _createVNode(LazyImage, {
                                                      src: imageSource(''),
                                                      alt: homePlan.name,
                                                      isNeighborhoodImage: false,
                                                      showDefaultImage: showDefaultImage.value
                                                    }, null, 8, ["src", "alt", "showDefaultImage"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", _hoisted_18, [
                                                _createElementVNode("h2", {
                                                  class: "homePlan-name",
                                                  onClick: ($event: any) => (
                          !_unref(isKioskMode)
                            ? openPlanDetails(homePlan.plan_url)
                            : openKioskPlanView(homePlan.id)
                        ),
                                                  style: {"cursor":"pointer"}
                                                }, [
                                                  _createTextVNode(_toDisplayString(homePlan.name) + " ", 1),
                                                  (
                            [_unref(availableStatus).FUTURE_HOME].includes(
                              _unref(lotInfo).lot.status
                            )
                          )
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "  " + _toDisplayString(homePlan.elevation), 1))
                                                    : _createCommentVNode("", true)
                                                ], 8, _hoisted_19),
                                                _createElementVNode("div", _hoisted_21, [
                                                  (!!homePlan.price_high &&
                        ![_unref(availableStatus).FUTURE_HOME].includes(_unref(lotInfo).lot.status))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Starts at"))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_23, [
                                                    (
                              [_unref(availableStatus).AVAILABLE].includes(
                                _unref(lotInfo).lot.status
                              ) && homePlan.price_low !== 0
                            )
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(formatPrice)(
                                _unref(lotInfo).lot.net_premium + homePlan.price_low
                              )), 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("p", _hoisted_25, [
                                                (!!homePlan.sqft_low || !!homePlan.sqft_high)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                                      (
                            checkLowRange('sqft_low', 'sqft_high', homePlan)
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(formatSquareFeet(homePlan.sqft_low)), 1))
                                                        : _createCommentVNode("", true),
                                                      (isRange(homePlan.sqft_low, homePlan.sqft_high))
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.sqft_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(formatSquareFeet(homePlan.sqft_high)), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[5] || (_cache[5] = _createTextVNode(" sq. ft. | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (!!homePlan.stories_low || !!homePlan.stories_high)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                                      (
                            checkLowRange(
                              'stories_low',
                              'stories_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(homePlan.stories_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(homePlan.stories_low, homePlan.stories_high)
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.stories_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(homePlan.stories_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[6] || (_cache[6] = _createTextVNode(" story | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.bedrooms_low || !!homePlan.bedrooms_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                                      (
                            checkLowRange(
                              'bedrooms_low',
                              'bedrooms_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(homePlan.bedrooms_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(
                              homePlan.bedrooms_low,
                              homePlan.bedrooms_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.bedrooms_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(homePlan.bedrooms_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[7] || (_cache[7] = _createTextVNode(" bed | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.fullbaths_low || !!homePlan.fullbaths_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                                      (
                            checkLowRange(
                              'fullbaths_low',
                              'fullbaths_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(homePlan.fullbaths_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(
                              homePlan.fullbaths_low,
                              homePlan.fullbaths_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.fullbaths_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(homePlan.fullbaths_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[8] || (_cache[8] = _createTextVNode(" full baths | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.halfbaths_low || !!homePlan.halfbaths_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                                      (
                            checkLowRangeHalfBath(
                              'halfbaths_low',
                              'halfbaths_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(homePlan.halfbaths_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRangeHalfBath(
                              homePlan.halfbaths_low,
                              homePlan.halfbaths_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.halfbaths_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(homePlan.halfbaths_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[9] || (_cache[9] = _createTextVNode(" half baths | ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                (
                          !!homePlan.garagebays_low ||
                          !!homePlan.garagebays_high
                        )
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                                      (
                            checkLowRange(
                              'garagebays_low',
                              'garagebays_high',
                              homePlan
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(homePlan.garagebays_low), 1))
                                                        : _createCommentVNode("", true),
                                                      (
                            isRange(
                              homePlan.garagebays_low,
                              homePlan.garagebays_high
                            )
                          )
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_48, "-"))
                                                        : _createCommentVNode("", true),
                                                      (!!homePlan.garagebays_high)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(homePlan.garagebays_high), 1))
                                                        : _createCommentVNode("", true),
                                                      _cache[10] || (_cache[10] = _createTextVNode(" car garage ", -1))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 16))
                                  : _createCommentVNode("", true)
                              ], 4))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "tabs",
                      id: "tabtwo",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSiteReInit()))
                    }, null, 512), [
                      [_vShow, !!_unref(lotInfo).lot.images.length]
                    ]),
                    _withDirectives(_createElementVNode("label", _hoisted_51, "Site photos", 512), [
                      [_vShow, !!_unref(lotInfo).lot.images.length]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _withDirectives(_createVNode(_unref(Carousel), _normalizeProps(_guardReactiveProps(carouselConfig)), {
                          addons: _withCtx(() => [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_unref(Navigation))
                            ])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lotInfo).lot.images, (image) => {
                              return (_openBlock(), _createBlock(_unref(Slide), {
                                key: image.seq_position
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(LazyImage, {
                                    src: imageSource(image),
                                    alt: image.caption,
                                    isNeighborhoodImage: false
                                  }, null, 8, ["src", "alt"]),
                                  (!!image.caption)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(image.caption), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 16), [
                          [_vShow, !!_unref(lotInfo).lot.images.length]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("h2", _hoisted_57, _toDisplayString(messages.sitePhotosH3Message), 1)
                      ]),
                      _createElementVNode("p", _hoisted_58, _toDisplayString(messages.sitePhotosPMessage), 1)
                    ], 512), [
                      [_vShow, !!_unref(lotInfo).lot.images.length]
                    ])
                  ]))
                : (
              [_unref(availableStatus).QUICK_MOVE_IN, _unref(availableStatus).MODEL].includes(
                _unref(lotInfo).lot.status
              )
            )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(lotInfo).homes_plans[0].move_in_date)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Move-in date: " + _toDisplayString(new Date() >= new Date((_unref(lotInfo)).homes_plans[0].move_in_date)
                  ? "Immediate"
                  : formatDate(_unref(lotInfo).homes_plans[0].move_in_date)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass({ tabs: lotStatus.value == 'qmi' })
                      }, [
                        _withDirectives(_createElementVNode("input", _hoisted_60, null, 512), [
                          [_vShow, lotStatus.value == 'qmi' && _unref(lotInfo).homes_plans.length]
                        ]),
                        _withDirectives(_createElementVNode("label", _hoisted_61, "Home Plans", 512), [
                          [_vShow, lotStatus.value == 'qmi' && _unref(lotInfo).homes_plans.length]
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lotInfo).homes_plans, (homePlan) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "tab",
                            key: homePlan.id
                          }, [
                            (_unref(lotInfo).lot.status !== 'Quick Move-In')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _createElementVNode("h2", _mergeProps({ class: "homePlan-name" }, _toHandlers(
                      !_unref(isKioskMode) && homePlan.plan_url
                        ? { click: () => openPlanDetails(homePlan.plan_url) }
                        : undefined
                    , true), {
                                    style: [
                      !_unref(isKioskMode)
                        ? { cursor: 'pointer' }
                        : { pointerEvents: 'none', textDecoration: 'none' },
                    ]
                                  }), [
                                    _createElementVNode("span", null, _toDisplayString(_unref(convertToTitleCase)(homePlan.name)), 1),
                                    (homePlan.elevation)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(homePlan.elevation), 1))
                                      : _createCommentVNode("", true)
                                  ], 16)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(_unref(Carousel), _mergeProps({ ref_for: true }, carouselConfig), {
                                addons: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_66, [
                                    _createVNode(_unref(Navigation))
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homePlan.image_url, (homePlanImage) => {
                                    return (_openBlock(), _createBlock(_unref(Slide), {
                                      key: homePlanImage.seq_position,
                                      class: "tab-slider"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(LazyImage, {
                                          src: imageSource(homePlanImage),
                                          alt: homePlanImage.caption,
                                          isNeighborhoodImage: false
                                        }, null, 8, ["src", "alt"]),
                                        (!!homePlanImage.title)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(homePlanImage.title), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  (!homePlan.image_url.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                        _createVNode(LazyImage, {
                                          src: imageSource(''),
                                          alt: '',
                                          isNeighborhoodImage: false
                                        }, null, 8, ["src"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            (_unref(lotInfo).lot.status === 'Quick Move-In')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                  _createElementVNode("h2", {
                                    class: "homePlan-name",
                                    onClick: ($event: any) => (
                      !_unref(isKioskMode)
                        ? openPlanDetails(homePlan.plan_url)
                        : openKioskPlanView(homePlan.id)
                    ),
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(homePlan.name), 1),
                                    (homePlan.elevation)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, "  " + _toDisplayString(homePlan.elevation), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_69),
                                  _createElementVNode("div", _hoisted_71, [
                                    (!!homePlan.price_high)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                                          (!!homePlan.wasprice)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_unref(formatPrice)(homePlan.wasprice)), 1))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(_unref(formatPrice)(homePlan.price_high)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_74, [
                              (
                      _unref(lotInfo).lot.status == 'Quick Move-In' &&
                      !!homePlan.target_date
                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(homePlan.target_date), 1))
                                : _createCommentVNode("", true),
                              (!!homePlan.sqft_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                                    _cache[11] || (_cache[11] = _createTextVNode(" Square Ft: ", -1)),
                                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(formatSquareFeet(homePlan.sqft_high)) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.stories_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                                    _cache[13] || (_cache[13] = _createTextVNode(" Story: ", -1)),
                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.stories_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.bedrooms_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                    _cache[15] || (_cache[15] = _createTextVNode(" Bedrooms: ", -1)),
                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.bedrooms_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.fullbaths_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                                    _cache[17] || (_cache[17] = _createTextVNode(" Full Baths: ", -1)),
                                    _cache[18] || (_cache[18] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.fullbaths_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.halfbaths_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                                    _cache[19] || (_cache[19] = _createTextVNode(" Half Baths: ", -1)),
                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.halfbaths_high) + " | ", 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (!!homePlan.garagebays_high)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_81, [
                                    _cache[21] || (_cache[21] = _createTextVNode(" Garage: ", -1)),
                                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "nbsp" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(homePlan.garagebays_high) + "-car ", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "tabs",
                          id: "tabtwo",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSiteReInit()))
                        }, null, 512), [
                          [_vShow, !!_unref(lotInfo).lot.images.length && lotStatus.value == 'qmi']
                        ]),
                        _withDirectives(_createElementVNode("label", _hoisted_82, "Site photos", 512), [
                          [_vShow, !!_unref(lotInfo).lot.images.length && lotStatus.value == 'qmi']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _withDirectives(_createVNode(_unref(Carousel), _normalizeProps(_guardReactiveProps(carouselConfig)), {
                              addons: _withCtx(() => [
                                _createElementVNode("div", _hoisted_86, [
                                  _createVNode(_unref(Navigation))
                                ])
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lotInfo).lot.images, (image) => {
                                  return (_openBlock(), _createBlock(_unref(Slide), {
                                    key: image.seq_position
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(LazyImage, {
                                        src: imageSource(image),
                                        alt: image.caption,
                                        isNeighborhoodImage: false
                                      }, null, 8, ["src", "alt"]),
                                      (!!image.caption)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(image.caption), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }, 16), [
                              [_vShow, !!_unref(lotInfo).lot.images.length]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("h3", _hoisted_88, _toDisplayString(messages.sitePhotosH3Message), 1)
                          ]),
                          _createElementVNode("p", _hoisted_89, _toDisplayString(messages.sitePhotosPMessage), 1)
                        ], 512), [
                          [_vShow, !!_unref(lotInfo).lot.images.length && lotStatus.value == 'qmi']
                        ])
                      ], 2)
                    ], 64))
                  : ([_unref(availableStatus).SOLD].includes(_unref(lotInfo).lot.status))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                        (!!_unref(lotInfo).homes_plans.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("h2", _hoisted_93, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(lotInfo).homes_plans[0].name), 1),
                                  (!!_unref(lotInfo).homes_plans[0].elevation)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, "  " + _toDisplayString(_unref(lotInfo).homes_plans[0].elevation), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (
                  !!_unref(lotInfo).homes_plans[0].image_url.length &&
                  !!_unref(lotInfo).homes_plans[0].image_url[0].image_url
                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                    _createElementVNode("div", _hoisted_96, [
                                      _createVNode(LazyImage, {
                                        src: imageSource(_unref(lotInfo).homes_plans[0].image_url[0]),
                                        alt: _unref(lotInfo).homes_plans[0].image_url[0].caption,
                                        isNeighborhoodImage: false
                                      }, null, 8, ["src", "alt"])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
              (showSoldMessage.value && !_unref(isSalesOrLandView))
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createTextVNode(_toDisplayString(trailingText.value[0]) + " ", 1),
                    _createElementVNode("span", {
                      class: "linkScheduleVisit",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(mobileOpenContactInfo)()))
                    }, _toDisplayString(_unref(linkOpenConatactInfo)), 1),
                    _createTextVNode(" " + _toDisplayString(trailingText.value[1]), 1)
                  ]))
                : _createCommentVNode("", true),
              (selfGuidedTourUrl.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: "btn schedule-visit-btn",
                    id: "btnSelfGuidedTour",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (openSelfGuidedTour()))
                  }, " Self Guided Tour "))
                : (!suppressScheduleVisit() && !_unref(isSalesOrLandView))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      class: "btn schedule-visit-btn",
                      id: "btnScheduleVisit",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(mobileOpenContactInfo)()))
                    }, " Schedule a Visit "))
                  : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(errorMessage)))
      ])
    ])
  ]))
}
}

})